<!--Componente generico che fa da wrapper a elementi dell'interfaccia quali icone, button, campi di testo, etc.
Tali elementi sono configurabili in termini di visibilità (hidden) e abilitazione (disabled) in base al PROFILO dell'utente collegato-->
<template>
    <div v-if="!hidden" :id="cid" :style="disabled ? 'position: relative;' : '' "> 
        <!--livello che copre l'elemento nello slot in modo da non innescare l'azione associata al click dell'elemento nello slot-->
        <div v-if="disabled" id="coverlayer" style="position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; z-index:99; cursor: not-allowed;"></div>
        <slot></slot>
    </div>
</template>
<script>

    export default {
        props: {
            cid: String,
            tag: String
        },
        mounted: function() {
            if(this.$Components[this.cid]){
                this.hidden =  this.$Components[this.cid].hidden
                this.disabled =  this.$Components[this.cid].disabled
                if(this.disabled){
                    switch(this.tag){
                        case 'i':
                            //imposto l'opacity dell'icona pari a 0.1. L'icona è figlia del cfg
                            document.getElementById(this.cid).firstElementChild.style.opacity = 0.1
                            break;
                        case 'div':
                            //imposto l'opacity del div pari a 0.5 
                            document.getElementById(this.cid).firstElementChild.style.opacity = 0.5
                            break;
                    }
                }
            }
        },
        methods: {
        },
        data: function(){
            return {
                hidden: false,
                disabled: false
            }
        }
    }
</script>
<style scoped>

</style>
<style>

</style>


// WEBPACK FOOTER //
// src/components/dynamic/ConfigurableComponent.vue?5bbfe972